<!--
 * @Author: qh_feng
 * @Date: 2022-03-20 21:52:49
 * @LastEditTime: 2022-04-04 20:00:26
  内容: 扩展 el-upload 上传文件组件，前提必须已经引入 element ui 库
 1.如果只有一个，这个imgList也是个数组 [{...,fileList:[]}]
 2. 如果是单图， 最多不能超过4个，多了样式需要自己修改

 传参例子：
<my-el-upload
        :on-success="onSuccess"
        :is-refresh-btn="openInputList"  //这个是开启“单图上传按钮”
        :list="imgList"
        :upload-img-api="'/api' + uploadImgApi"
      ></my-el-upload>

 list=[
   {
     title:"标题",
    fileList: [
      {
        name: item.title,
        url: item.value
      }
    ]
 }
];
onSuccess(imgList, res, key) {
      imgList.forEach((params) => {
        let arr = [];
        params.fileList.forEach((item) => {
          arr.push(item.url);
        });
        this.ruleForm[params.keyName] = arr.join(',');  //imgList传入这里面要带有keyName属性，值就是ruleForm表单对象的键值
      });
    },
-->
<template>
  <div
    class="my-el-upload u-p5-b-2"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 1)"
  >
    <!-- v-if="title == titleType[1]" -->
    <div v-if="imgList.length" :class="[limit == 1 ? 'myflex' : '']">
      <div
        v-for="(item, key) in imgList"
        :key="key"
        :class="[`my-position-absolute my-left${imgList.length}-${key}`]"
      >
        <div class="u-color-white">
          <i style="font-size: 16px" class="el-icon-picture-outline"></i>
          <h3 style="margin-left: 12px; display: inline-block">
            {{ item.title }}
          </h3>
        </div>
        <el-upload
          :key="refKey"
          ref="upload"
          :show-file-list="showFileList"
          :name="name"
          :multiple="multiple"
          :auto-upload="autoUpload"
          :headers="headers"
          :data="data"
          :list-type="listType"
          :action="uploadImgApi"
          :on-success="(file) => el_onSuccess(file, key)"
          :limit="outLimit"
          :on-preview="(res) => el_onPreview(res, key)"
          :on-error="(res) => el_onError(res, key)"
          :on-change="(res) => el_onChange(res, key)"
          :on-remove="(res) => el_onRemove(res, key)"
          :on-progress="(res) => el_onProgress(res, key)"
          :on-exceed="(res) => el_onExceed(res, key)"
          :before-remove="(res) => el_beforeRemove(res, key)"
          :before-upload="beforeAvatarUpload"
          :file-list="item.fileList || emptyArr"
        >
          <i slot="default" class="my-el-upload-upload-btn el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview u-position-relative"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
                <span
                  style="font-size: 12px; width: 28px"
                  class="u-position-absolute u-l--6 u-b--20"
                  >放大</span
                >
              </span>
              <span
                v-if="isDownBtn && !dialogVisible"
                class="el-upload-list__item-delete u-position-relative"
                @click="handleDownload(file, key)"
              >
                <i class="el-icon-download"></i>
                <span
                  style="font-size: 12px; width: 28px"
                  class="u-position-absolute u-l--6 u-b--20"
                  >下载</span
                >
              </span>
              <span
                v-if="isRefreshBtn && !dialogVisible"
                class="el-upload-list__item-delete u-position-relative"
                @click="clickUploadBtn(file, key)"
              >
                <i class="el-icon-refresh-left"></i>
                <span
                  style="font-size: 12px; width: 28px"
                  class="u-position-absolute u-l--6 u-b--20"
                  >替换</span
                >
              </span>
              <span
                v-if="limit !== 1 && isDelBtn && !dialogVisible"
                class="el-upload-list__item-delete u-position-relative"
                @click="handleRemove(file, key)"
              >
                <i class="el-icon-delete"></i>
                <span
                  style="font-size: 12px; width: 28px"
                  class="u-position-absolute u-l--6 u-b--20"
                  >删除</span
                >
              </span>
            </span>
          </div>
        </el-upload>
      </div>
    </div>

    <el-image-viewer
      v-if="!!bigImgSrc"
      :on-close="close_dbClickImgBox"
      :url-list="[bigImgSrc]"
    />
  </div>
</template>

<script>
import ElImageViewer from "@/components/CustomImageViewer";

export default {
  name: "Test",
  props: {
    resUrlHierarchy: {
      type: Array,
      default: () => [], // 请求返回的url所在层级,如 response.data.imgSrc 则传['response','data','imgSrc']
    },
    fileType: {
      type: String,
      default: "image/jpeg", //默认文件类型
    },
    fileSize: {
      type: [String, Number],
      default: 2, //默认限制2M
    },
    limit: {
      type: [String, Number],
      default: 1,
    },
    listType: {
      type: String,
      default: "picture-card",
    },
    uploadImgApi: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "file",
    },
    showFileList: {
      type: Boolean,
      default: true,
    },
    isRefreshBtn: {
      type: Boolean,
      default: false,
    },
    isDownBtn: {
      type: Boolean,
      default: false,
    },
    isDelBtn: {
      type: Boolean,
      default: false,
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    beforeUpload: Function,
    onPreview: Function,
    onError: Function,
    onRemove: Function,
    onProgress: Function,
    beforeRemove: Function,
    onExceed: Function,
    onSuccess: Function,
  },
  components: {
    ElImageViewer,
  },
  data() {
    return {
      loading: false,
      refKey: "a1",
      dialogVisaveDialogWidthsible: "",
      dialogVisible: false,
      outLimit: 0,
      saveFirstImgList: [],
      imgList: [],
      emptyArr: [],
      bigImgSrc: "",
    };
  },
  methods: {
    clickUploadBtn(file, key) {
      this.preFile = file;
      document.querySelectorAll(".my-el-upload-upload-btn.el-icon-plus")[key].click();
    },
    close_dbClickImgBox() {
      this.bigImgSrc = "";
    },
    el_onExceed(res, key) {
      console.log(res, key);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === this.fileType;
      const isLt2M = file.size / 1024 / 1024 < this.fileSize;
      this.loading = true;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        this.loading = false;
      }
      if (typeof this.beforeUpload === "function") {
        this.beforeUpload(file);
      }

      return isJPG && isLt2M;
    },
    clearFiles() {
      if (this.imgList.length) {
        this.imgList.forEach((params, index) => {
          this.$refs.upload[index].clearFiles();
          (() => {
            setTimeout(() => {
              document.querySelectorAll(".el-upload.el-upload--picture-card")[
                index
              ].style.display = "block";
            }, 1500);
          })(index);
        });
        // this.imgList = this.$myPlug.deepCopy(this.list);
        this.imgList = JSON.parse(JSON.stringify(this.saveFirstImgList));
      }
    },
    el_onSuccess(res, key) {
      if (typeof this.onSuccess === "function") {
        let url = "";
        if (this.resUrlHierarchy.length) {
          for (let i = 1; i < this.resUrlHierarchy.length; i++) {
            res = res[this.resUrlHierarchy[i]];
          }
          url = res;
        } else {
          const arr = JSON.stringify(res).match(/http(.*)\.jpg/i);
          url = arr[0];
        }
        if (this.limit === 1) {
          if (this.imgList[key].fileList.length) {
            const row = this.preFile ? this.preFile.raw : null;
            this.$refs.upload[key].handleRemove(this.preFile, this.preFile.raw);
          }

          setTimeout(() => {
            // document.querySelectorAll('.el-upload.el-upload--picture-card')[
            //   key
            // ].style.display = 'none';
            this.initImgListShow();
            setTimeout(() => {
              this.loading = false;
            }, 2500);
          }, 50);

          this.imgList[key].fileList = [
            {
              name: "file",
              url,
            },
          ];
        } else {
          this.imgList[key].fileList.push({
            name: "file",
            url,
          });
        }
        this.refKey = "tt1";

        this.onSuccess(this.imgList, res, key);
      }
    },
    el_onPreview(res, key) {
      if (typeof this.onPreview === "function") this.onPreview(res, key);
    },
    el_onError(res, key) {
      if (typeof this.onError === "function") this.onError(res, key);
    },
    el_onChange(res, key) {
      if (typeof this.onChange === "function") this.onChange(res, key);
    },
    el_onRemove(res, key) {
      if (typeof this.onRemove === "function") this.onRemove(res, key);
    },
    el_onProgress(res, key) {
      if (typeof this.onProgress === "function") this.onProgress(res, key);
    },
    el_beforeRemove(res, key) {
      if (typeof this.beforeRemove === "function") this.beforeRemove(res, key);
    },
    handlePictureCardPreview(file) {
      this.bigImgSrc = file.url;
    },
    handleRemove(file, key) {
      this.$refs.upload[key].handleRemove(file, file.raw);
      this.imgList[key].fileList.splice(
        this.imgList[key].fileList.findIndex((item) => item.url == file.url),
        1
      );
      if (typeof this.onRemove === "function") this.onRemove(this.imgList, file, key);
    },
    handleDownload(file, key) {
      console.log(file);
    },
    initImgListShow() {
      if (this.limit === 1 && this.imgList.length) {
        this.imgList.forEach((params, key) => {
          if (params.fileList.length)
            document.querySelectorAll(".el-upload.el-upload--picture-card")[
              key
            ].style.display = "none";
        });
        if (this.imgList.length > 3) {
          this.saveDialogWidth = document.querySelector(
            ".el-dialog.my-car-detail.car_dialog"
          ).style.width;
          document.querySelector(".el-dialog.my-car-detail.car_dialog").style.width =
            "80%";
        }
      }
    },
  },
  mounted() {
    this.initImgListShow();
  },
  created() {
    this.saveFirstImgList = JSON.parse(JSON.stringify(this.list));
    this.imgList = this.list;
    this.outLimit = this.limit === 1 ? 2 : this.limit;
  },
  destroyed() {
    if (this.imgList.length > 3) {
      document.querySelector(
        ".el-dialog.my-car-detail.car_dialog"
      ).style.width = this.saveDialogWidth;
    }
  },
};
</script>

<style lang="scss">
.my-el-upload {
  .myflex {
    display: flex !important;
    box-sizing: border-box !important;
    height: 200px;
  }
  .my-position-absolute {
    position: absolute;
  }
  .my-left3-0 {
    left: 10%;
  }
  .my-left3-1 {
    left: 40%;
  }
  .my-left3-2 {
    left: 70%;
  }
  /*扩展4个卡片加的 */

  .my-left4-0 {
    left: 80px;
  }
  .my-left4-1 {
    left: 400px;
  }
  .my-left4-2 {
    left: 720px;
  }
  .my-left4-3 {
    left: 1040px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/My-el-upload.vue